// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)// import axios from './axios/index'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import { getStore } from "./until/until";
import echarts from 'echarts';
import VueCliboard from 'vue-clipboard2';
import htmlToPdf from './until/htmlToPdf';
import ElTableBar from 'el-table-bar-base';
import 'el-table-bar-base/lib/ElTableBar.css';
import 'default-passive-events'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'
// 使用Vue.use()方法就会调用工具方法中的install方法
Vue.use(VXETable)
Vue.use(ElTableBar);
Vue.use(htmlToPdf);
Vue.use(ElementUI);
Vue.use(VueCliboard);
Vue.prototype.$echarts = echarts;
Vue.prototype.$store = store;
router.beforeEach((to, from, next) => {
  let session = getStore('token');
  if (!session) {
    if (to.path == '/Login') {
      next();
    } else {
      next({
        path: '/Login'
      });
    }

  } else {
    if (to.path === '/Login') {
      return next({ path: '/operateHome' });
    } else {
      next();
    }
  }
})

/* eslint-disable no-new */
new Vue({
  store,
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js